module.exports = __webpack_public_path__ + "img/datosdc.1d2eae05.png";